import { downloadWaveData } from '@bpm-web-app/utils';
import useSWR from 'swr';

export function useWaveData(datUrl: string) {
    const { data } = useSWR(datUrl, downloadWaveData);

    return data;
}
